import { createUseStyles } from 'react-jss';
import { Theme } from '../../Theme';
export const useStyles = createUseStyles<string, {}, Theme>({
  primaryFieldContainer: {
    position: 'absolute',
    top: ({ theme }) => theme.scale * 60,
    maxWidth: ({ theme }) => theme.scale * 320,
  },
});
